package com.narbase.letsgo.web.views.voiceassistant

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSessionLogDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.GetVoiceAssistantSessionAudioEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.GetVoiceAssistantSessionsEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class VoiceAssistantSessionsViewModel {

    val sessionsUiState = Observable<BasicUiState>()

    var sessions = emptyArray<VoiceAssistantSessionLogDto>()
        private set
    var total = 0
        private set
    var pageNo = 0
        private set
    var pageSize = 20
        private set
    private var searchTerm: String? = null

    fun getSessions() {
        basicNetworkCall(sessionsUiState) {
            val response = GetVoiceAssistantSessionsEndpoint.remoteProcess(
                GetVoiceAssistantSessionsEndpoint.Request(
                    pageNo = pageNo,
                    pageSize = pageSize,
                    searchTerm = searchTerm,
                )
            ).data
            sessions = response.list
            total = response.total
        }
    }

    fun searchSessionsFor(term: String) {
        searchTerm = term.takeIf { it.isNotBlank() }
        pageNo = 0
        getSessions()
    }

    fun getNextPage() {
        pageNo += 1
        getSessions()
    }

    fun getPreviousPage() {
        if (pageNo == 0) return
        pageNo -= 1
        getSessions()
    }

    fun loadTurnAudio(turnId: String, onLoaded: (String?) -> Unit) {
        basicNetworkCall(Observable()) {
            val response = GetVoiceAssistantSessionAudioEndpoint.remoteProcess(
                GetVoiceAssistantSessionAudioEndpoint.Request(turnId)
            ).data
            val audioBase64 = response.audioBase64
            onLoaded(
                if (audioBase64.isNullOrBlank()) null
                else "data:${response.audioMimeType ?: "audio/webm"};base64,$audioBase64"
            )
        }
    }
}
